import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Field } from 'react-final-form';
import InputMask from 'react-input-mask';
import { connect } from 'react-redux';
import { compose, required, code as SMSCode, minLength } from 'utils/validation';
import { actions } from 'app/redux/modules/form';
import appSettings from 'config/application/app-settings';
import Result from 'components/Result';
import { addGoogleEvent } from '../../utils/googleAnalytics';
import FieldText from '../FieldText';
import { Fields, Form as FormStyle } from './Form.style';
import Wizard from './Wizard';

const parseDigits = value => (value && value.replace(/\D/g, '')) || undefined;

const redirectTo = url => {
  window.location.href = url;
};
/**
 * sbjs - Объект который присутствует на сайте raiffeisen.ru, в котором
 * содержатся данные о пользователе. Используется для аналитики поведения пользователя
 */
const src = (window.sbjs && window.sbjs.get && window.sbjs.get.current && window.sbjs.get.current.src) || '';

class FormComponent extends React.PureComponent {
  static propTypes = {
    postLead: PropTypes.func.isRequired, // eslint-disable-line
    requestCode: PropTypes.func.isRequired, // eslint-disable-line
    sendCode: PropTypes.func.isRequired,
    isCreatingLeadRequest: PropTypes.bool,
    isCheckingCodeRequest: PropTypes.bool,
    accountId: PropTypes.string
  };

  componentDidMount() {
    addGoogleEvent({
      event: 'VirtualPageview',
      virtualPageURL: '/account/sme/step1',
      virtualPageTitle: 'ЛК - SME Digital - Шаг 1 - Телефон',
      pageType: 'Promopage',
      categoryName: 'Рассчетно-кассовое обслуживание',
      checkoutStepName: 'LPForm',
      checkoutStepNumber: '1',
      'gtm.uniqueEventId': 6
    });
  }

  handleSubmitPhone = async ({ phone }) => {
    const normalizePhone = phone.replace(new RegExp(' ', 'g'), '').replace('+7', '');

    try {
      const leadCreateResponse = await this.props.postLead({
        phoneNumber: normalizePhone
      });

      const { authenticationType, phoneNumber } = leadCreateResponse.data;
      if (authenticationType === 'SMS_AUTHENTICATION') {
        await this.props.requestCode({ phoneNumber });
        addGoogleEvent({
          event: 'VirtualPageview',
          virtualPageURL: '/account/sme/step2',
          virtualPageTitle: 'ЛК - SME Digital - Шаг 2 - Телефон, email, ФИО',
          pageType: 'Promopage',
          categoryName: 'Рассчетно-кассовое обслуживание',
          checkoutStepName: 'LPForm',
          checkoutStepNumber: '2'
        });
        addGoogleEvent({
          event: 'GAevent',
          eventCategory: 'send_ok',
          eventAction: 'rko_sme_landing-phone',
          eventLabel: `${src}_order:${this.props.accountId}`
        });
      } else {
        redirectTo(appSettings.RBO_REDIRECT_URL);
      }
    } catch (e) {
      return {
        phone: 'Произошла ошибка, приносим свои извинения'
      };
    }
    return undefined;
  };

  handleSubmitCode = async ({ code }) => {
    try {
      const authorizeResponse = await this.props.sendCode({
        code
      });
      if (authorizeResponse.url) {
        addGoogleEvent({
          event: 'VirtualPageview',
          virtualPageURL: '/account/sme/step2/1',
          virtualPageTitle: 'ЛК - SME Digital - Шаг 2.1 – Подтвердил СМС-код',
          pageType: 'Promopage',
          categoryName: 'Рассчетно-кассовое обслуживание',
          checkoutStepName: 'LPForm',
          checkoutStepNumber: '2.1'
        });
        redirectTo(authorizeResponse.url);
      }
    } catch (e) {
      const responseData = get(e, 'response.data');
      return {
        code: responseData.message || 'Произошла ошибка, приносим свои извинения'
      };
    }
    return undefined;
  };

  phoneValidate = compose(
    value => required(value, 'Укажите полный номер телефона'),
    value => minLength(value, 16, 'Укажите полный номер телефона')
  );

  codeValidate = value => SMSCode(value);

  render() {
    const { isCreatingLeadRequest, isCheckingCodeRequest } = this.props;

    return (
      <FormStyle>
        <Fields>
          <Wizard>
            <Wizard.Page onSubmit={this.handleSubmitPhone}>
              <Field
                component={FieldText}
                label="Введите номер телефона"
                key="phone"
                name="phone"
                id="phone"
                type="tel"
                validate={this.phoneValidate}
                InputComponent={InputMask}
                mask="+7 999 999 99 99"
                autoComplete="off"
                maskChar={null}
                isLoading={isCreatingLeadRequest}
              />
            </Wizard.Page>
            <Wizard.Page onSubmit={this.handleSubmitCode}>
              <Field
                autoSubmit
                autoFocus
                component={FieldText}
                focusOnMount
                id="code"
                isLoading={isCheckingCodeRequest}
                isActive
                key="code"
                label="Введите код подтверждения из SMS"
                maxLength="5"
                name="code"
                validate={this.codeValidate}
                parse={parseDigits}
              />
            </Wizard.Page>
            <Wizard.Page>
              <Result />
            </Wizard.Page>
          </Wizard>
        </Fields>
      </FormStyle>
    );
  }
}

export default connect(
  state => ({
    isCreatingLeadRequest: state.form.isCreatingLead,
    isCheckingCodeRequest: state.form.isCheckingCode,
    accountId: state.form.accountId
  }),
  actions
)(FormComponent);
